module.exports = __webpack_public_path__ + "static/media/culture.ceea5369.jpg";